import SelectField from '@pelckmans/elementis/components/select-field';
import { useTranslation } from 'react-i18next';

const TRANSLATION_KEY = 'PAGES.MY_GROUPS.MODALS.IMPORT_MEMBERS.LINK_MEMBERS_DATA';

export const linkColumnOptions = {
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  PASSWORD: 'PASSWORD',
  EMAIL: 'EMAIL',
  USERNAME: 'USERNAME',
  DONT_LINK: 'DONT_LINK',
};

const OPTIONAL_OPTIONS = [linkColumnOptions.EMAIL, linkColumnOptions.USERNAME] as const;

interface Props {
  onChange: (linkToColumnIndex: number, value: string) => void;
  valuesByColumnIndex?: Record<number, typeof linkColumnOptions[keyof typeof linkColumnOptions]>;
  linkToColumnIndex: number;
}

export default function SelectFieldToLink({ onChange, valuesByColumnIndex, linkToColumnIndex }: Props) {
  const { t } = useTranslation();

  const handleOnChange = (value: string) => {
    onChange(linkToColumnIndex, value);
  };

  const selectedValues = Object.values(valuesByColumnIndex || {}).filter(
    value => value !== linkColumnOptions.DONT_LINK,
  );
  const filteredOptions = Object.values(linkColumnOptions).filter(option => !selectedValues.includes(option));

  return (
    <SelectField
      id={`to-link-${linkToColumnIndex}`}
      className="field"
      onChange={handleOnChange}
      renderValueContent={value => t(`${TRANSLATION_KEY}.TO_LINK.OPTIONS.${value}`)}
      labelText={linkToColumnIndex === 0 ? t(`${TRANSLATION_KEY}.TO_LINK.LABEL`) : ''}
      dropdownMenuProps={{
        ariaLabel: t(`${TRANSLATION_KEY}.TO_LINK.OPTIONS.A11Y_LABEL`),
      }}
      value={valuesByColumnIndex?.[linkToColumnIndex] || linkColumnOptions.DONT_LINK}
      required
    >
      {filteredOptions.map((option, index) => (
        <SelectField.Item
          key={option}
          text={t(`${TRANSLATION_KEY}.TO_LINK.OPTIONS.${option}`)}
          value={option}
          showSeparator={index === filteredOptions.length - 1}
          disabled={false}
          subText={OPTIONAL_OPTIONS.includes(option) ? t(`${TRANSLATION_KEY}.TO_LINK.OPTIONS.OPTIONAL`) : undefined}
        />
      ))}
    </SelectField>
  );
}
